module.exports = __webpack_public_path__ + "static/media/brand5.edf49d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/brand5.png
// module id = 534
// module chunks = 0